import type { Plage } from '@/services/types/Rappel';

export const useTimeZoneFormatter = () => {
  const getCurrentOffset = (() => {
    const detectedTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const offsetMinutes = new Date().getTimezoneOffset();
    const offsetHours = Math.floor(Math.abs(offsetMinutes) / 60);
    const offsetMins = Math.abs(offsetMinutes) % 60;
    const sign = offsetMinutes <= 0 ? '+' : '-';
    const formattedOffset = `UTC${sign}${String(offsetHours).padStart(2, '0')}:${String(offsetMins).padStart(2, '0')}`;
    return {
      timeZone: detectedTimeZone,
      utcOffset: formattedOffset,
      offsetHours: sign === '+' ? offsetHours : -offsetHours,
      offsetMinutes: offsetMinutes,
    };
  })();

  const formatTimeRange = (plage: Plage): string => {
    const { timeZone, utcOffset } = getCurrentOffset;
    return `${plage.debutH}h - ${plage.finH}h (${timeZone} ${utcOffset})`;
  };

  return {
    formatTimeRange,
  };
};
